import { render, staticRenderFns } from "./ExternalPrintCollect.vue?vue&type=template&id=2c0995c7&scoped=true&"
import script from "./ExternalPrintCollect.vue?vue&type=script&lang=ts&"
export * from "./ExternalPrintCollect.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalPrintCollect.vue?vue&type=style&index=0&id=2c0995c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0995c7",
  null
  
)

export default component.exports